import styled from "styled-components";
import Textarea from "react-autosize-textarea";
import { V3Body, V3BodyCSS } from "../Typography";
import { InputStyleProps, InputMixin } from "../SharedInputComponent";
import { V3RightIconPositioner } from "../SharedInputComponent/SharedInputComponent.styles";
import { AuthoryColorSchemeProps, isContrastWithDarkHigher, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";
import { hexToRgba } from "../../utils/hexToRGBA";

interface V3IptProps extends InputStyleProps {
    $hasCharacterLimit?: boolean,
}

const V3ThemableInpit = styled(V3Body)<{ $allowUserThemable: boolean } & AuthoryColorSchemeProps & V3IptProps>`
    ${InputMixin};

    ${({ $allowUserThemable }) => $allowUserThemable && UserThemableHeading}

    opacity: ${({ $allowUserThemable, theme }) => {
        if(!$allowUserThemable) return 1;
        return isContrastWithDarkHigher(theme.customization.backgroundColor) ? 1 : 0.6;
    }};

    background-color: ${({ theme, $allowUserThemable }) =>{
        if(!$allowUserThemable) return theme.v3.colors.grey96;
        return hexToRgba(theme.customization.backgroundColor, 1);
    }};

    border: ${({ theme, $allowUserThemable }) => {
        if(!$allowUserThemable) return;
        return `1px solid ${isContrastWithDarkHigher(theme.customization.backgroundColor) ? theme.v3.colors.grey88 : theme.v3.colors.grey88}`;
    }};

    &:focus {
        border: ${({ theme, $allowUserThemable }) => {
            if(!$allowUserThemable) return;
            return `1px solid ${isContrastWithDarkHigher(theme.customization.backgroundColor) ? theme.v3.colors.grey88 : theme.v3.colors.grey88}`;
        }};
        box-shadow: none;
    }
`;

export const V3Ipt = styled(V3ThemableInpit)`
    padding-right: ${({ $hasCharacterLimit }) => {
        if ($hasCharacterLimit) return "75px";
        return undefined;
    }};
`;

export const V3TA = styled(Textarea) <V3IptProps>`
    ${V3BodyCSS};
    ${InputMixin};
    resize: none;
    display: block;
    min-height: 100px;
    padding-bottom: ${({ $hasCharacterLimit }) => {
        if ($hasCharacterLimit) return "25px";
        return undefined;
    }};

    + ${V3RightIconPositioner} {
        right: ${({ $hasCharacterLimit }) => $hasCharacterLimit ? "initial" : undefined};
        bottom: ${({ $hasCharacterLimit }) => $hasCharacterLimit ? "5px" : undefined};
        top:  ${({ $hasCharacterLimit }) => $hasCharacterLimit ? "initial" : undefined};
        left:  ${({ $hasCharacterLimit }) => $hasCharacterLimit ? "18px" : undefined};
    }
`;